import Button from 'components/Form/Button';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { POST } from 'services/api';
import styled from 'styled-components';

// --- Estilos de Componentes (Simplificados) ---
export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  &.closing {
    animation: fadeOut 0.3s forwards;
  }
`;

export const ModalContainer = styled.div`
  background-color: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  position: relative;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-sizing: border-box;

  @media (max-width: 768px) {
    width: 95%;
    padding: 20px;
  }
  &.closing {
    animation: slideOut 0.3s forwards;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
  h2 {
    margin: 0;
    font-size: 24px;
    color: #333;
  }
`;

export const ModalContent = styled.div`
  padding: 0 10px;
`;

export const CompanyButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
    button {
      width: 100%;
    }
  }
`;

const FormTextarea = styled.textarea`
  width: 100%;
  padding: 12px;
  border: 1px solid ${({ error }) => (error ? 'red' : '#ced4da')};
  border-radius: 8px;
  box-sizing: border-box;
  font-size: 16px;
  background-color: #f8f9fa;
  margin-top: 15px;
  min-height: 100px;
  resize: vertical;
  margin-bottom: 20px;
  color: #333333;
  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
`;

const FormSelect = styled.select`
  width: 100%;
  padding: 12px;
  border: 1px solid ${({ error }) => (error ? 'red' : '#ced4da')};
  border-radius: 8px;
  box-sizing: border-box;
  font-size: 16px;
  background-color: #f8f9fa;
  margin-top: 15px;
  margin-bottom: 20px;
  color: #333333;
  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
`;

const ErrorMessage = styled.div`
  color: #ff6b6b;
  font-size: 14px;
  margin-top: 5px;
  margin-bottom: 10px;
`;

// Componente Principal
export default function ModalDeclinarProposta({
  proposalId,
  codPropostaExterna,
  onClose,
  isClosing = false,
  reloadContent,
}) {
  const [loading, setLoading] = useState(false);
  const [observation, setObservation] = useState('');
  const [opcoes_declinada, setOpcoesDeclinada] = useState('');
  const [observationError, setObservationError] = useState(false);
  const [opcaoError, setOpcaoError] = useState(false);

  const opcoes = [
    { value: '', label: 'Selecione uma opção...' },
    { value: 'Declinada pelo Cliente', label: 'Declinada pelo Cliente' },
    { value: 'Declinada pelo Vendedor', label: 'Declinada pelo Vendedor' },
    { value: 'Declinada pela Evon', label: 'Declinada pela Evon' },
  ];

  const handleSave = async () => {
    // Reset de erros
    setObservationError(false);
    setOpcaoError(false);
    let hasError = false;
    // Validação da observação
    if (!observation.trim()) {
      setObservationError(true);
      hasError = true;
    } else if (observation.length > 500) {
      setObservationError(true);
      hasError = true;
    }
    // Validação da opção
    if (!opcoes_declinada) {
      setOpcaoError(true);
      hasError = true;
    }
    if (hasError) {
      toast.error('Preencha todos os campos obrigatórios corretamente.');
      return;
    }
    setLoading(true);

    try {
      const url = '/webhook/attformalizar';
      const body = {
        proposta: proposalId,
        status: 'declinada',
        observacao: observation,
        opcao: opcoes_declinada, // Exatamente como pedido
      };
      const result = await POST(url, body, true);
      if (result && result.status === 'ok') {
        toast.success(
          `Proposta ${codPropostaExterna} foi declinada com sucesso!`
        );
        if (reloadContent) reloadContent();
        onClose();
      } else {
        const errorMessage =
          result?.erro || 'Erro desconhecido na resposta da API.';
        toast.error(`Erro ao atualizar a proposta: ${errorMessage}`);
      }
    } catch (error) {
      console.error('Ocorreu um erro na requisição:', error);
      toast.error(`Ocorreu um erro: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Overlay className={isClosing ? 'closing' : ''} onClick={onClose}>
      <ModalContainer
        className={isClosing ? 'closing' : ''}
        onClick={(e) => e.stopPropagation()}
      >
        <ModalHeader>
          <h2>Declinar Proposta {codPropostaExterna || proposalId}</h2>
        </ModalHeader>
        <ModalContent>
          <p>
            Preencha o campo de <b>justificativa detalhada</b> e{' '}
            <b>selecione o motivo do declínio</b> para documentação.
          </p>
          {/* Select de Opções */}
          <label htmlFor="opcao-declinio">Motivo do Declínio:</label>
          <FormSelect
            id="opcao-declinio"
            value={opcoes_declinada}
            onChange={(e) => setOpcoesDeclinada(e.target.value)}
            error={opcaoError}
          >
            {opcoes.map((opt) => (
              <option
                key={opt.value}
                value={opt.value}
                disabled={opt.value === ''}
              >
                {opt.label}
              </option>
            ))}
          </FormSelect>
          {opcaoError && (
            <ErrorMessage>Selecione uma opção válida.</ErrorMessage>
          )}
          {/* Observação */}
          <label htmlFor="observation">Justificativa:</label>
          <FormTextarea
            id="observation"
            value={observation}
            onChange={(e) => setObservation(e.target.value)}
            error={observationError}
            placeholder="Digite sua justificativa detalhada aqui..."
          />
          {observationError && (
            <ErrorMessage>
              {observation.length > 500
                ? 'A observação não pode exceder 500 caracteres.'
                : 'A justificativa é obrigatória.'}
            </ErrorMessage>
          )}
        </ModalContent>
        <CompanyButtonContainer>
          <Button onClick={onClose} color="lightgrey" border nospace>
            Cancelar
          </Button>
          <Button onClick={handleSave} loading={loading} color="blue" nospace>
            {loading ? 'Declinando...' : 'Declinar'}
          </Button>
        </CompanyButtonContainer>
      </ModalContainer>
    </Overlay>
  );
}
